/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

export enum ERROR_KEY {
  GENERIC = 'GENERIC',
  BUSINESS_EXCEPTION_TRANSACTION_AUTHENTICATION_OPTION_IS_EXPIRED = 'BUSINESS_EXCEPTION_TRANSACTION_AUTHENTICATION_OPTION_IS_EXPIRED',
  BUSINESS_EXCEPTION_TRANSACTION_AUTHENTICATION_OPTION_IS_EXPIRED_PROSPECT = 'BUSINESS_EXCEPTION_TRANSACTION_AUTHENTICATION_OPTION_IS_EXPIRED_PROSPECT',
  BUSINESS_EXCEPTION_TRANSACTION_AUTHENTICATION_OPTION_IS_EXPIRED_SECONDARY = 'BUSINESS_EXCEPTION_TRANSACTION_AUTHENTICATION_OPTION_IS_EXPIRED_SECONDARY',
  BUSINESS_EXCEPTION_TRANSACTION_ALREADY_CONFIRMED_OR_ABORTED = 'BUSINESS_EXCEPTION_TRANSACTION_ALREADY_CONFIRMED_OR_ABORTED',
  BUSINESS_EXCEPTION_TRANSACTION_BLACKLISTED_PORSCHE_ID = 'BUSINESS_EXCEPTION_TRANSACTION_BLACKLISTED_PORSCHE_ID',
  BUSINESS_CONSTRAINT_PROFILE_TMP_DATA_NOT_FOUND = 'BUSINESS_CONSTRAINT_PROFILE_TMP_DATA_NOT_FOUND',
  FORBIDDEN_UNEXPECTED_USER = 'FORBIDDEN_UNEXPECTED_USER',

  RESOURCE_NOT_FOUND_SHORTLINK = 'RESOURCE_NOT_FOUND_SHORTLINK',
}

export const errorPageData = new Map<ERROR_KEY, ErrorPageData>([
  [
    ERROR_KEY.GENERIC,
    {
      headline: 'signup.errorPage.unknownError.headline',
      headlineContext: 'signup.errorPage.unknownError.headlineContext',
      subline: 'signup.errorPage.unknownError.subline',
      button: {
        label: 'signup.errorPage.unknownError.button.label',
        type: 'primary',
        externalTarget: 'porscheCom',
      },
      image: 'assets/images/error-generic@1536w1x.jpg',
      responsiveImages: [
        {
          type: 'image/webp',
          srcSet: 'assets/images/error-generic@1536w1x.webp 1x',
        },
        {
          type: 'image/jpg',
          srcSet: 'assets/images/error-generic@1536w1x.jpg 1x',
        },
      ],
    },
  ],
  [
    ERROR_KEY.BUSINESS_EXCEPTION_TRANSACTION_BLACKLISTED_PORSCHE_ID,
    {
      headline: 'signup.errorPage.emailDeny.headline',
      headlineContext: 'signup.errorPage.emailDeny.headlineContext',
      subline: 'signup.errorPage.emailDeny.subline',
      button: {
        label: 'signup.errorPage.unknownError.button.label',
        type: 'primary',
        externalTarget: 'porscheCom',
      },
      image: 'assets/images/error-generic@1536w1x.jpg',
      responsiveImages: [
        {
          type: 'image/webp',
          srcSet: 'assets/images/error-generic@1536w1x.webp 1x',
        },
        {
          type: 'image/jpg',
          srcSet: 'assets/images/error-generic@1536w1x.jpg 1x',
        },
      ],
    },
  ],
  [
    ERROR_KEY.BUSINESS_EXCEPTION_TRANSACTION_AUTHENTICATION_OPTION_IS_EXPIRED,
    {
      headline: 'signup.owner.errorPage.expiredLink.headline',
      headlineContext: 'signup.owner.errorPage.expiredLink.headlineContext',
      subline: 'signup.owner.errorPage.expiredLink.subline',
      image: 'assets/images/error-expired@1536w1x.jpg',
      responsiveImages: [
        {
          type: 'image/webp',
          srcSet: 'assets/images/error-expired@1536w1x.webp 1x',
        },
        {
          type: 'image/jpg',
          srcSet: 'assets/images/error-expired@1536w1x.jpg 1x',
        },
      ],
    },
  ],
  [
    ERROR_KEY.RESOURCE_NOT_FOUND_SHORTLINK,
    {
      headline: 'signup.owner.errorPage.expiredLink.headline',
      headlineContext: 'signup.owner.errorPage.expiredLink.headlineContext',
      subline: 'signup.owner.errorPage.expiredLink.subline',
      image: 'assets/images/error-expired@1536w1x.jpg',
      responsiveImages: [
        {
          type: 'image/webp',
          srcSet: 'assets/images/error-expired@1536w1x.webp 1x',
        },
        {
          type: 'image/jpg',
          srcSet: 'assets/images/error-expired@1536w1x.jpg 1x',
        },
      ],
    },
  ],
  [
    ERROR_KEY.BUSINESS_CONSTRAINT_PROFILE_TMP_DATA_NOT_FOUND,
    {
      headline: 'signup.owner.errorPage.expiredLink.headline',
      headlineContext: 'signup.owner.errorPage.expiredLink.headlineContext',
      subline: 'signup.owner.errorPage.expiredLink.subline',
      image: 'assets/images/error-expired@1536w1x.jpg',
      responsiveImages: [
        {
          type: 'image/webp',
          srcSet: 'assets/images/error-expired@1536w1x.webp 1x',
        },
        {
          type: 'image/jpg',
          srcSet: 'assets/images/error-expired@1536w1x.jpg 1x',
        },
      ],
    },
  ],
  [
    ERROR_KEY.BUSINESS_EXCEPTION_TRANSACTION_AUTHENTICATION_OPTION_IS_EXPIRED_PROSPECT,
    {
      headline: 'signup.prospect.errorPage.expiredLink.headline',
      headlineContext: 'signup.prospect.errorPage.expiredLink.headlineContext',
      subline: 'signup.prospect.errorPage.expiredLink.subline',
      button: {
        label: 'signup.prospect.errorPage.create.button',
        type: 'primary',
        target: 'register',
      },
      image: 'assets/images/error-expired@1536w1x.jpg',
      responsiveImages: [
        {
          type: 'image/webp',
          srcSet: 'assets/images/error-expired@1536w1x.webp 1x',
        },
        {
          type: 'image/jpg',
          srcSet: 'assets/images/error-expired@1536w1x.jpg 1x',
        },
      ],
    },
  ],
  [
    ERROR_KEY.BUSINESS_EXCEPTION_TRANSACTION_AUTHENTICATION_OPTION_IS_EXPIRED_SECONDARY,
    {
      headline: 'signup.prospect.errorPage.expiredLink.headline',
      headlineContext: 'signup.secondary.errorPage.expiredLink.headlineContext',
      subline: 'signup.secondary.errorPage.expiredLink.subline',
      button: {
        label: 'signup.prospect.errorPage.create.button',
        type: 'primary',
        target: 'register',
      },
      image: 'assets/images/error-expired@1536w1x.jpg',
      responsiveImages: [
        {
          type: 'image/webp',
          srcSet: 'assets/images/error-expired@1536w1x.webp 1x',
        },
        {
          type: 'image/jpg',
          srcSet: 'assets/images/error-expired@1536w1x.jpg 1x',
        },
      ],
    },
  ],
  [
    ERROR_KEY.BUSINESS_EXCEPTION_TRANSACTION_ALREADY_CONFIRMED_OR_ABORTED,
    {
      headline: 'signup.errorPage.alreadyConfirmed.headline',
      headlineContext: 'signup.errorPage.alreadyConfirmed.headlineContext',
      subline: 'signup.errorPage.alreadyConfirmed.subline',
      image: 'assets/images/error-already-confirmed@1536w2x.jpg',
      textInside: true,
      // WCAG 2.2.1: replaced the silent 5s auto-redirect with a manual CTA so users
      // are not punished by a moving target when reading the message.
      button: {
        label: 'signup.errorPage.continueButton.label',
        type: 'primary',
        externalTarget: 'myPorscheHome',
      },
      responsiveImages: [
        {
          media: '(max-width: 639px)',
          type: 'image/webp',
          srcSet: 'assets/images/error-already-confirmed@576w1x.webp 1x, assets/images/error-already-confirmed@576w2x.webp 2x',
        },
        {
          media: '(max-width: 639px)',
          type: 'image/jpg',
          srcSet: 'assets/images/error-already-confirmed@576w1x.jpg 1x, assets/images/error-already-confirmed@576w2x.jpg 2x',
        },
        {
          type: 'image/webp',
          srcSet: 'assets/images/error-already-confirmed@1536w1x.webp 1x, assets/images/error-already-confirmed@1536w2x.webp 2x',
        },
        {
          type: 'image/jpg',
          srcSet: 'assets/images/error-already-confirmed@1536w1x.jpg 1x, assets/images/error-already-confirmed@1536w2x.jpg 2x',
        },
      ],
    },
  ],
  [
    ERROR_KEY.FORBIDDEN_UNEXPECTED_USER,
    {
      headline: 'signup.errorPage.unexpectedUser.headline',
      headlineContext: 'signup.errorPage.unexpectedUser.headlineContext',
      subline: 'signup.errorPage.unexpectedUser.subline',
      image: 'assets/images/unexpected-user@858w1x.jpg',
      textInside: false,
      responsiveImages: [
        {
          media: '(max-width: 1000px)',
          type: 'image/webp',
          srcSet: 'assets/images/unexpected-user@662w1x.webp 1x',
        },
        {
          media: '(max-width: 1000px)',
          type: 'image/jpg',
          srcSet: 'assets/images/unexpected-user@662w1x.jpg 1x',
        },
        {
          type: 'image/webp',
          srcSet: 'assets/images/unexpected-user@858w1x.webp 1x',
        },
        {
          type: 'image/jpg',
          srcSet: 'assets/images/unexpected-user@858w1x.jpg 1x',
        },
      ],
    },
  ],
])

export interface ErrorPageImageData {
  media?: string
  type: string
  srcSet: string
}

export interface ErrorPageButtonData {
  label: string
  target?: string
  externalTarget?: string
  action?: () => void
  type?: 'primary' | 'secondary'
}

export interface ErrorPageData {
  error?: ERROR_KEY
  textInside?: boolean
  headline: string
  /**
   * Translation key for a screen-reader-only sentence rendered next to the H1
   * (e.g. "Time's up" gets the spoken context "Your activation link is no longer valid").
   * Visible copy stays in `subline`; this exists so AT users hear the meaning before
   * they tab into the body text. WCAG 2.4.6 (Headings and Labels).
   */
  headlineContext?: string
  subline: string
  button?: ErrorPageButtonData
  image?: string
  responsiveImages: ErrorPageImageData[]
}
